import { z } from "zod";
import { PassengerType } from "@trainline/dpi/lib/types";
import DateType from "@trainline/dpi/lib/types/DateType";
import { DisabilityCardLevel } from "../primitives/Passengers/types/PassengerDisability";
const railcard = z.object({
  id: z.string().optional(),
  code: z.string(),
  number: z.string().optional()
});
const passengerCard = z.object({
  id: z.string().optional(),
  code: z.string(),
  number: z.string().optional(),
  enabled: z.boolean().optional()
});
const disabilityInformation = z.object({
  wheelchairUser: z.boolean(),
  disabilityCardLevel: z.nativeEnum(DisabilityCardLevel)
});
const passenger = z.object({
  id: z.string().optional(),
  firstName: z.string().optional(),
  type: z.nativeEnum(PassengerType),
  dateOfBirth: z.string().optional(),
  cards: passengerCard.array().optional(),
  disabilityInformation: disabilityInformation.optional(),
  profileId: z.string().optional()
});
const rdsLocation = z.object({
  name: z.string(),
  translatedName: z.string().optional(),
  countryCode: z.string(),
  code: z.string(),
  score: z.number().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  shortName: z.string().optional(),
  extraInfo: z.object({
    subtitle: z.string().optional(),
    attributes: z.string().array().optional()
  }).optional(),
  locationType: z.string().optional(),
  defaultLanguage: z.string().optional(),
  parent: z.object({
    locationType: z.string().optional(),
    name: z.string(),
    translatedName: z.string().optional()
  }).optional(),
  timezone: z.string().optional(),
  connections: z.string().array(),
  explanation: z.string().optional(),
  displayName: z.string().optional()
});
const promo = z.discriminatedUnion("inventory", [
  z.object({
    inventory: z.literal("EU"),
    voucherCode: z.string(),
    passengerIndex: z.number()
  }),
  z.object({
    inventory: z.literal("ATOC"),
    voucherCode: z.string()
  })
]);
const coordinatesSchema = z.object({
  latitude: z.number(),
  longitude: z.number()
});
const locationStateSchema = z.object({
  isLoaded: z.boolean(),
  isLoading: z.boolean(),
  requestedBy: z.string(),
  coordinates: coordinatesSchema.nullable(),
  error: z.object({
    code: z.number(),
    message: z.string(),
    PERMISSION_DENIED: z.number(),
    POSITION_UNAVAILABLE: z.number(),
    TIMEOUT: z.number()
  }).optional()
});
const timePreferenceSchema = z.enum([DateType.ArriveBefore, DateType.DepartAfter]);
export {
  PassengerType,
  coordinatesSchema,
  disabilityInformation,
  locationStateSchema,
  passenger,
  passengerCard,
  promo,
  railcard,
  rdsLocation,
  timePreferenceSchema
};
